export enum S1ScheduleStatus{
    STATUS_PENDING = "STATUS_PENDING",
	STATUS_RUNNING = "STATUS_RUNNING",
	STATUS_DONE = "STATUS_DONE",
	STATUS_FAILED = "STATUS_FAILED",
	STATUS_DELETING = "STATUS_DELETING",
	STATUS_INTERRUPTED = "STATUS_INTERRUPTED",
	STATUS_WATING_DOWNLOAD = "STATUS_WATING_DOWNLOAD",
	STATUS_DOWNLOADING = "STATUS_DOWNLOADING"
}